var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_633245",
    "data-name": "Group 633245",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858301",
    "data-name": "Path 858301",
    d: "M0,0H25V25H0Z",
    fill: "#806b2d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_858302",
    "data-name": "Path 858302",
    d: "M16.5,4A12.5,12.5,0,1,0,29,16.5,12.5,12.5,0,0,0,16.5,4Zm0,18.75a1.25,1.25,0,1,1,1.25-1.25A1.254,1.254,0,0,1,16.5,22.75Zm1.25-5a1.25,1.25,0,1,1-2.5,0V11.5a1.25,1.25,0,0,1,2.5,0Z",
    transform: "translate(-4 -4)",
    fill: "#226e8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858303",
    "data-name": "Path 858303",
    d: "M0,0H25V25H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlert);
export default __webpack_public_path__ + "static/media/InfoAlert.01dbd2b0db6fa170812c5886f361376a.svg";
export { ForwardRef as ReactComponent };